module.exports = __webpack_public_path__ + "static/resource-work-from-home-52b713f1e7e593e7171cdad479d54f5f.png";